import { FunctionComponent } from 'react';

import { Checkbox, FormControl, FormControlLabel, InputLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { BreakoutCreateMode } from '../enums/BreakoutCreateMode';
import { StyledRowContainer } from '../styles/styled-components';

const CreateLabel = withStyles(() => ({
    root: {
        color: '#4739E7',
        lineHeight: '30px',
        fontSize: '24px',
        textAlign: 'left',
        fontWeight: 'bold'
    }
}))(InputLabel);

const BreakoutRoomCreatorInitialSetup: FunctionComponent = () => {
    const { t } = useTranslation('breakout_room');
    const { roomCount, changeRoomCount, getUsersPerRoom, tempCreateMode, changeTempCreateMode, allowChangeRooms, setAllowChangeRooms } = useContainer(BreakoutRoomOptionsContainer);

    const handleModeChanged = (_event: React.ChangeEvent<HTMLInputElement>, value) => {
        const mode = value as BreakoutCreateMode;

        changeTempCreateMode(mode);

        if (mode === BreakoutCreateMode.AllowChoice) {
            setAllowChangeRooms(true);
        }
    };

    const handleCheckState = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setAllowChangeRooms(checked);
    };

    return (
        <>
            <StyledRowContainer>
                <CreateLabel>{t('create')}</CreateLabel>
                <TextField type='number' value={roomCount} onChange={changeRoomCount}
                    InputProps={{
                        style: {
                            width: '75px',
                            height: '30px',
                            fontSize: '24px',
                            marginLeft: '10px',
                            marginRight: '10px'
                        }
                    }}
                />
                <CreateLabel>{t('Breakout-Rooms')}</CreateLabel>
            </StyledRowContainer>
            <InputLabel style={{ marginTop: 10 }}>{getUsersPerRoom()} {t('participants-per-room')}</InputLabel>
            <StyledRowContainer />
            <StyledRowContainer>
                <FormControl component="fieldset">
                    <RadioGroup
                        defaultValue="auto"
                        name="radio-buttons-group"
                        value={tempCreateMode}
                        onChange={handleModeChanged}
                    >
                        <FormControlLabel value={BreakoutCreateMode.AssignAuto} control={<Radio />} label={t('assign-automatically') as string} />
                        <FormControlLabel value={BreakoutCreateMode.AssignManual} control={<Radio />} label={t('assign-manually') as string} />
                        <FormControlLabel value={BreakoutCreateMode.AllowChoice} control={<Radio />} label={t('allow-choice') as string} />
                    </RadioGroup>
                    <FormControlLabel
                        style={{ marginTop: '25px' }}
                        control={<Checkbox checked={allowChangeRooms}
                            onChange={handleCheckState}
                            disabled={tempCreateMode === BreakoutCreateMode.AllowChoice} />}
                        label={t('allow-change') as string} />
                </FormControl>
            </StyledRowContainer>
        </>
    );
};

export default BreakoutRoomCreatorInitialSetup;
